import { AFEX } from 'config';

const description =
  'AFEX Nigeria strives to transform Nigerian agriculture by creating more bargaining power to smallholder farmers, access to information, and secure storage.';
const commonProps = {
  description,
  image: AFEX.LOGO,
  twitterCardType: 'summary',
  facebookCardType: 'website',
};

export const pageConfigMap = {
  default: { name: '', slug: '', ...commonProps },
  home: { name: 'Home', slug: '', ...commonProps },
  about: { name: 'About Us', slug: 'about', ...commonProps },
  market: { name: 'Market', slug: 'market', ...commonProps },
  trybe: { name: 'Trybes Men', slug: 'trybes-men', ...commonProps },
  updates: { name: 'Updates', slug: 'updates', ...commonProps },
  workbench: { name: 'Workbench', slug: 'workbench', ...commonProps },
  404: { name: 'Not Found', slug: 'not-found', ...commonProps },
  efficientMarkets: {
    name: 'Efficient Markets',
    slug: 'efficient-markets',
    ...commonProps,
  },
  accessAndRetention: {
    name: 'Access and Retention',
    slug: 'access-and-retention',
    ...commonProps,
  },
  bigDataAnalytics: {
    name: 'Big Data and Analytics',
    slug: 'big-data-analytics',
    ...commonProps,
  },
};
export const titlePrefix = 'AFEX';
export const twitterHandle = '@AFEXNigeria';
